import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pg-redirect',
  templateUrl: './pg-redirect.component.html',
  styleUrls: ['./pg-redirect.component.scss']
})
export class PgRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
